import {InquiryMultiField} from "./inquiry_multi_field";

export const PersonNameFieldConfig = {
    baseHtmlClass: 'inquiry_field--person_name',
    selector: '.inquiry_field--person_name',

    firstnameInputNameAttribute: 'person[firstname]',
    surnameInputNameAttribute: 'person[surname]'
}

export class PersonNameField extends InquiryMultiField {

    static new(InquiryForm) {
        if (!InquiryForm.element) { return null }
        const element = InquiryForm.element.querySelector(PersonNameFieldConfig.selector);
        if (element) { return new PersonNameField(element, InquiryForm) }
    }

    constructor(id_or_element, InquiryForm) {
        super(id_or_element, InquiryForm);
    }



    // Input and value accessors for individual inputs…

    // Firstname…

    getFirstnameAtInput() {
        let firstnameInput = null;
        this.inputElements.forEach( (input) => {
            if (input.getAttribute('name') === PersonNameFieldConfig.firstnameInputNameAttribute) { firstnameInput = input }
        });
        return firstnameInput;
    }

    getFirstnameInputValue() {
        const input = this.getFirstnameAtInput();
        const value = input ? input.value : null;
        return this.typecastValue(value);
    }

    // Surname…

    getSurnameAtInput() {
        let surnameInput = null;
        this.inputElements.forEach( (input) => {
            if (input.getAttribute('name') === PersonNameFieldConfig.surnameInputNameAttribute) { surnameInput = input }
        });
        return surnameInput;
    }

    getSurnameInputValue() {
        const input = this.getSurnameAtInput();
        const value = input ? input.value : null;
        return this.typecastValue(value);
    }



    // Returns the single value as calculated by looking at each of the inputs.
    getInputsValue() {
        let value = this.getInputsValues().join(' ').trim();
        return (value);
    }

    typecastValue(value) {
        if (value === '' || value === null) { return null }
        value = String(value);
        return value;
    }

    hasValue() {
        return this.value !== null && this.value !== '';
    }

    beforeUpdate() {
        this.errorChecking = true;
        // if (this.InquiryForm.hasCurrentPerson()) { this.errorChecking = false } // No error checking when we have a current person.
        // if (!this.InquiryForm.hasCommittedMinimumRequirements()) { this.errorChecking = false } // No error checking until user has committed the minimum requirements.
        super.beforeUpdate();
    }

    appendErrors() {
        if (!this.getFirstnameInputValue()) { this.errors.push(`${ this.label } must include your first name.`) }
        if (!this.getSurnameInputValue()) { this.errors.push(`${ this.label } must include your surname.`) }
    }

}